module.exports = __webpack_public_path__ + "static/media/Orcamentos9.73eaac61.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos9.png
// module id = 2105
// module chunks = 0